import * as XLSX from '@e965/xlsx';
import type { Site } from '../types';

/**
 * Strip HTML tags from a string
 */
function stripHtml(html: string): string {
  if (!html) return '';
  return html.replace(/<[^>]*>/g, '').replace(/&nbsp;/g, ' ').trim();
}

/**
 * Export sites to Excel format using SheetJS
 */
export function exportSitesToExcel(sites: Site[], filename?: string): void {
  const headers = [
    'Name',
    'Account',
    'Account Number',
    'Abbreviations',
    'Tags',
    'Address',
    'City',
    'Province',
    'Postal Code',
    'Country',
    'Phone',
    'Email',
    'Description',
    'Status',
    'Created At',
  ];

  const rows = sites.map((site) => [
    site.name || '',
    site.accountName || '',
    site.accountNumber || '',
    (site.abbreviations || []).join('; '),
    (site.tags || []).join('; '),
    site.addressLine1 || site.address || '',
    site.city || '',
    site.stateProvince || site.state_province_county || '',
    site.postalCode || site.postcode || '',
    site.country || '',
    site.phone || '',
    site.email || '',
    stripHtml(site.description || ''),
    site.disabled ? 'Inactive' : 'Active',
    site.createdAt ? new Date(site.createdAt).toLocaleDateString() : '',
  ]);

  const data = [headers, ...rows];
  const ws = XLSX.utils.aoa_to_sheet(data);

  ws['!cols'] = [
    { wch: 25 }, // Name
    { wch: 20 }, // Account
    { wch: 15 }, // Account Number
    { wch: 20 }, // Abbreviations
    { wch: 25 }, // Tags
    { wch: 25 }, // Address
    { wch: 15 }, // City
    { wch: 15 }, // Province
    { wch: 12 }, // Postal Code
    { wch: 12 }, // Country
    { wch: 15 }, // Phone
    { wch: 20 }, // Email
    { wch: 30 }, // Description
    { wch: 10 }, // Status
    { wch: 12 }, // Created At
  ];

  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, 'Sites');

  const exportFilename = filename || `sites-export-${new Date().toISOString().split('T')[0]}.xlsx`;
  XLSX.writeFile(wb, exportFilename);
}
